import { tv } from "@fanka/tailwind-variants";

export const TOOL_BUTTON_CLASS = tv({
  base: "h-8 w-8 flex items-center justify-center",
  variants: {
    active: {
      false: "[&_svg]:fill-ui-300",
      true: "[&_svg]:fill-ui-500",
    },
  },
});
